import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PermissoesProvider, usePermissoes } from './context/PermissoesContext';   // r87/r158
import { ToastProvider } from './context/ToastContext';              // r87
import RotaComPermissao from './components/RotaComPermissao';        // r87
import RotaProtegida from './components/RotaProtegida';
import PortalLayout from './components/Layout/PortalLayout';
import LoginPage from './pages/Login/LoginPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import EmBreve from './pages/EmBreve';
import UsuariosPage from './pages/Usuarios/UsuariosPage';
import GruposAcessoPage from './pages/GruposAcesso/GruposAcessoPage';
import ColaboradoresPage from './pages/Colaboradores/ColaboradoresPage';
import ClientesPage from './pages/Clientes/ClientesPage';
import NegociosPage from './pages/Negocios/NegociosPage';
import EmpresasPage from './pages/Empresas/EmpresasPage';
import CondicoesPagamentoPage from './pages/CondicoesPagamento/CondicoesPagamentoPage';
import PlanejamentoPage from './pages/Planejamento/PlanejamentoPage';
import ExecucaoTecnicaPage from './pages/ExecucaoTecnica/ExecucaoTecnicaPage';   // r221
import HorariosColaboradoresPage from './pages/HorariosColaboradores/HorariosColaboradoresPage';
import TarefasPage from './pages/Tarefas/TarefasPage';
import LancamentosHorasPage from './pages/LancamentosHoras/LancamentosHorasPage';
import PeriodosPage from './pages/Periodos/PeriodosPage';
import AcessosPage from './pages/Acessos/AcessosPage';


// ─── Wrapper que combina proteção de rota + layout do portal ─────────────────
// Assim não precisamos repetir RotaProtegida + PortalLayout em cada rota
function PaginaInterna({ children }) {
  return (
    <RotaProtegida>
      <PortalLayout>
        {children}
      </PortalLayout>
    </RotaProtegida>
  );
}

// r158: rotas da seção SISTEMA só são acessíveis por administradores.
//       Esconde do menu E redireciona se tentar acessar pela URL.
function AdminOnly({ children }) {
  const { isAdmin, isBootstrap } = usePermissoes();
  if (!isAdmin && !isBootstrap) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <PermissoesProvider>
      <BrowserRouter>
        <Routes>

          {/* ── Rota pública ── */}
          <Route path="/login"          element={<LoginPage />} />
          <Route path="/reset-password" element={<LoginPage />} />

          {/* ── Rotas protegidas ── */}
          <Route path="/dashboard"      element={<PaginaInterna><DashboardPage /></PaginaInterna>} />

          {/* Cadastros */}
          <Route path="/usuarios"       element={<PaginaInterna><RotaComPermissao rotina="usuarios"><UsuariosPage /></RotaComPermissao></PaginaInterna>} />
          <Route path="/grupos-acesso"  element={<PaginaInterna><RotaComPermissao rotina="grupos-acesso"><GruposAcessoPage /></RotaComPermissao></PaginaInterna>} />
          <Route path="/empresas"       element={<PaginaInterna><RotaComPermissao rotina="empresas"><EmpresasPage /></RotaComPermissao></PaginaInterna>} />
          <Route path="/colaboradores"  element={<PaginaInterna><RotaComPermissao rotina="colaboradores"><ColaboradoresPage /></RotaComPermissao></PaginaInterna>} />
          <Route path="/clientes"       element={<PaginaInterna><RotaComPermissao rotina="clientes"><ClientesPage /></RotaComPermissao></PaginaInterna>} />
          <Route path="/condicoes-pagamento" element={<PaginaInterna><RotaComPermissao rotina="condicoes-pagamento"><CondicoesPagamentoPage /></RotaComPermissao></PaginaInterna>} />
          <Route path="/acessos" element={<PaginaInterna><RotaComPermissao rotina="acessos"><AcessosPage /></RotaComPermissao></PaginaInterna>} />

          {/* Comercial */}
          <Route path="/crm"            element={<PaginaInterna><RotaComPermissao rotina="crm"><NegociosPage /></RotaComPermissao></PaginaInterna>} />

          {/* Técnica */}
	  <Route path="/planejamento"  element={<PaginaInterna><RotaComPermissao rotina="planejamento"><PlanejamentoPage /></RotaComPermissao></PaginaInterna>} />
	  <Route path="/execucao-tecnica" element={<PaginaInterna><RotaComPermissao rotina="execucao-tecnica"><ExecucaoTecnicaPage /></RotaComPermissao></PaginaInterna>} />

          {/* Tarefas (transversal — todos os módulos) */}
          <Route path="/tarefas"       element={<PaginaInterna><RotaComPermissao rotina="tarefas"><TarefasPage /></RotaComPermissao></PaginaInterna>} />


          {/* Rota raiz — redireciona para dashboard */}
          <Route path="/"               element={<Navigate to="/dashboard" replace />} />

	  <Route path="/horarios-colaboradores" element={<PaginaInterna><AdminOnly><RotaComPermissao rotina="horarios-colaboradores"><HorariosColaboradoresPage /></RotaComPermissao></AdminOnly></PaginaInterna>} />
	  <Route path="/lancamentos-horas" element={<PaginaInterna><RotaComPermissao rotina="lancamentos-horas"><LancamentosHorasPage /></RotaComPermissao></PaginaInterna>} />
          <Route path="/periodos" element={<PaginaInterna><AdminOnly><RotaComPermissao rotina="periodos"><PeriodosPage /></RotaComPermissao></AdminOnly></PaginaInterna>} />
	</Routes>
      </BrowserRouter>
        </PermissoesProvider>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
